import Schema from 'AppReact/schema';
import { group, property } from "types";

export default {
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  isReadonly: Schema('boolean', 'primitive', { defaultValue: false }),
  searchTerm: Schema('string', 'primitive', { defaultValue: '' }),
  properties: Schema(property, 'array', { defaultValue: [] }),
  groups: Schema(group, 'array', { defaultValue: [] }),
  selectedPropertyIds: Schema('integer', 'array', { defaultValue: [] }),
  selectedGroupIds: Schema('integer', 'array', { defaultValue: [] }),
  label: Schema("string", "primitive", { defaultValue: '' }),
  headerWidth: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  containerRef: Schema({}, 'object', { defaultValue: null }),
  inputRef: Schema({}, 'object', { defaultValue: null }),
  auto_add_new_properties: Schema('boolean', 'primitive', { defaultValue: false }),
  searchPlaceholder: Schema('string', 'primitive-nullable', { defaultValue: null })
}